import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Image from '../common/Image';
import { ErrorToast, formateDate, sortItemsBySelection } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import useCollection from './hooks/useCollection';
import ReactInfiniteScroll from '../common/ReactInfiniteScroll';

const useStyle = makeStyles({
  container: {
    height: '72vh',
    background: '#F2F4F7',
  },
  inputField: {
    width: '97%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },

  equlaIcon: {
    fontSize: '18px',
  },

  newJourneyCard: {
    background: '#fff',
    padding: '10px',
    width: '45%',
    borderRadius: '10px',
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
    height: '70px',
    margin: '10px',
  },

  journeyImg: {
    height: '80px',
    width: '60px',
  },
  jouneyContent: {
    width: '100%',
  },
  jouneyTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  journeyDate: {
    fontSize: '12px',
  },

  addNewJourney: {
    display: 'flex',
    gap: '15px',
    width: '95%',
  },

  checkbox: {
    width: '18px',
    height: '18px',
  },
  wrapper: {
    height: '59vh',
    marginTop: '10px',
    overflow: 'hidden',
    overflowY: 'auto',
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px',
  },
});

export function JourneyList({ selectedJid, setSelectedJid, asssignedJ, setAssignedJ, assignedJid, setAssignedJid }) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { fetchJourneys } = useCollection();

  const allJourney = useSelector((state) => state.GetJourneyList.journeylist);
  const collectionInfo = useSelector((state) => state.getCollection.collection);

  const [filteredJ, setJourneyJ] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  useEffect(() => {
    fetchJourneys();
  }, [fetchJourneys]);

  useEffect(() => {
    setJourneyJ(allJourney);
  }, [allJourney]);

  const handleSearch = (e) => {
    const input = e.target.value;
    setSearchVal(input);
    const filteredArray = input
      ? allJourney.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
      : allJourney;
    setJourneyJ(filteredArray);
  };

  const getJourneys = async () => {
    dispatch(showProgress(true));
    try {
      const result = await service.get(apiEndpoints.COLLECTION_JOURNEYS.replace('ID', collectionInfo.id));
      setAssignedJ(result || []);
      const ids = result?.map((i) => i.id) || [];
      setSelectedJid((prevIds) => [...new Set([...prevIds, ...ids])]);
      setAssignedJid(ids);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (collectionInfo?.id) {
      getJourneys();
    }
  }, [collectionInfo]);

  const handleAddJ = (data) => {
    const { id } = data;

    if (!assignedJid.includes(id)) {
      const temp = [...selectedJid];
      if (temp.includes(id)) {
        const indx = temp.indexOf(id);
        temp.splice(indx, 1);
        setSelectedJid(temp);
        const tempJ = asssignedJ?.filter((i) => i.id !== data.id);
        setAssignedJ(tempJ || []);
      } else {
        temp.push(id);
        setAssignedJ([...asssignedJ, data]);
        setSelectedJid(temp);
      }
    }
  };

  // Selected list should move up in the list
  const sortedJourneys = sortItemsBySelection(selectedJid, filteredJ, 'id') || [];

  return (
    <Grid className={classes.container}>
      <Grid style={{ padding: '10px' }}>
        <input placeholder="Search journey" className={classes.inputField} value={searchVal} onChange={handleSearch} />
      </Grid>
      <div className={classes.wrapper} style={{ overflow: 'hidden' }}>
        <ReactInfiniteScroll
          size={20}
          data={sortedJourneys}
          renderItem={(data) => {
            const isDisable = assignedJid.includes(data.id);
            return (
              <Grid className={classes.newJourneyCard} key={data.id}>
                <p className={classes.equlaIcon}>
                  <input
                    type="checkbox"
                    className={classes.checkbox}
                    style={{ opacity: isDisable ? '0.4' : '1' }}
                    onClick={() => {
                      handleAddJ(data);
                    }}
                    checked={selectedJid.includes(data.id)}
                  />
                </p>
                <Grid className={classes.addNewJourney}>
                  <Image
                    className={classes.journeyImg}
                    src={data.thumbnail}
                    alt="Journey Pic"
                    style={{ opacity: isDisable ? '0.4' : '1' }}
                  />
                  <Grid className={classes.jouneyContent}>
                    <Grid className={classes.jouneyTitle} style={{ opacity: isDisable ? '0.4' : '1' }}>
                      <Typography noWrap style={{ width: '300px' }}>
                        {data.title}
                      </Typography>
                    </Grid>
                    <Typography
                      variant="p"
                      className={classes.journeyDate}
                      style={{ opacity: isDisable ? '0.4' : '1' }}
                    >
                      {formateDate(data.publishDate)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          }}
          height="59vh"
          width="100%"
        />
      </div>
    </Grid>
  );
}
